'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsWinterhike } from '@/types'
import { StatusChip } from '@/ui/components'
import { memo } from 'react'

const AccordionHead = ({ ...data }: Typo3ReportsWinterhike) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={''}>
      <h3 className={cn('', 'h3')}>{data.title}</h3>
      <div className={''}>
        <div className={''}>
          <div className="text-small text-neutral-400">
            {D['fe.winterHike.trails']}
          </div>
          <div>
            <span
              className={cn(
                'text-large',
                'font-weight-700',
                data.status === 'CLOSED'
                  ? 'text-feedback-red'
                  : 'text-feedback-green'
              )}
            >
              {data.numberTrailsOpen}
            </span>{' '}
            {D['fe.reports.from']}{' '}
            <span
              className={cn(
                'text-large',
                'font-weight-700',
                data.status === 'CLOSED'
                  ? 'text-feedback-red'
                  : 'text-feedback-green'
              )}
            >
              {data.numberTrails}
            </span>{' '}
            {D['fe.reports.open']}
          </div>
        </div>
        <div className={''}>
          <div className="text-small text-neutral-400">
            {D['fe.winterHike.status']}
          </div>
          <div className={''}>
            <StatusChip status={data.status === 'OPEN' ? 'success' : 'error'} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(AccordionHead)
